import React from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';
import { StyledLi, StyledLink, StyledButton } from './CollectionsListItemStyles';

var CollectionsListItem = function CollectionsListItem(_ref) {
  var url = _ref.url,
      image = _ref.image,
      title = _ref.title;
  return React.createElement(
    StyledLi,
    null,
    React.createElement(
      StyledLink,
      { 'aria-label': 'Go to ' + title, href: '/' + url },
      React.createElement(Image, { src: image, alt: title })
    ),
    React.createElement(
      'h3',
      null,
      title
    ),
    React.createElement(
      StyledButton,
      { href: '/' + url, className: 'btn' },
      'Shop This Room'
    )
  );
};

CollectionsListItem.propTypes = {
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default CollectionsListItem;